class RemoveChildProducts extends HTMLElement {
  constructor() {
    super();
    this.products = this.dataset.products?.split(',') || [];
  }

  connectedCallback() {
    this.init();
  }

  init() {
    // Fetch the current cart
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const itemsToRemove = [];

        // Loop through cart items and find matching products
        cart.items.forEach(item => {
          if (this.products.includes(String(item.properties['Parent id']))) {
            itemsToRemove.push(item.key); // Use item.key directly
          }
        });

        if (itemsToRemove.length === 0) {
          console.log('No matching products found in cart.');
          return;
        }

        // Send one bulk update request to remove items
        const updates = {};
        itemsToRemove.forEach(id => (updates[id] = 0));

        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates }),
        })
          .then(res => res.json())
          .then(response => {
            console.log('Removed products:', response);

            document.dispatchEvent(
              new CustomEvent('cart:refresh', { detail: { scrollToTop: false } })
            );
          })
          .catch(error => console.error('Error removing products:', error));
      })
      .catch(err => console.error('Error fetching cart:', err));
  }
}

customElements.define('remove-child-products', RemoveChildProducts);
